// R17 Wave 0 extraction — pure refactor, no behavior change
import React from 'react';
import { FileText, Download } from 'lucide-react';

interface BlotterReportFiltersProps {
  date: string;
  onDateChange: (next: string) => void;
  onGenerate: () => void;
  onDownloadExcel: () => void;
  loading: boolean;
  downloadingExcel: boolean;
  showExportButtons: boolean;
  error: string | null;
}

/**
 * Date-picker + Generate/Excel action bar for the Blotter Report page.
 * Extracted from BlotterReport.tsx in R17 Wave 0 so R17 Task C's UI merge-list
 * (union of blotter-dates + check-dates) can be introduced here without
 * further inflating the parent file.
 */
const BlotterReportFilters: React.FC<BlotterReportFiltersProps> = ({
  date,
  onDateChange,
  onGenerate,
  onDownloadExcel,
  loading,
  downloadingExcel,
  showExportButtons,
  error,
}) => {
  return (
    <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6 mb-6">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <div className="md:col-span-2">
          <label htmlFor="date" className="block text-sm font-medium text-gray-700 mb-2">
            Blotter Date
          </label>
          <input
            type="date"
            id="date"
            value={date}
            onChange={(e) => onDateChange(e.target.value)}
            className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-transparent"
          />
        </div>

        <div className="flex items-end gap-3">
          <button
            onClick={onGenerate}
            disabled={loading || !date}
            className="flex-1 bg-primary-600 text-white px-6 py-2 rounded-lg hover:bg-primary-700 disabled:bg-gray-300 disabled:cursor-not-allowed transition-colors flex items-center justify-center"
          >
            <FileText className="h-4 w-4 mr-2" />
            Generate Report
          </button>
          {showExportButtons && (
            <button
              onClick={onDownloadExcel}
              disabled={downloadingExcel || !date}
              className="bg-emerald-700 text-white px-4 py-2 rounded-lg hover:bg-emerald-800 disabled:bg-gray-300 disabled:cursor-not-allowed transition-colors flex items-center justify-center whitespace-nowrap"
              title="Download Excel"
            >
              <Download className="h-4 w-4 mr-2" />
              {downloadingExcel ? 'Downloading...' : 'Excel'}
            </button>
          )}
        </div>
      </div>

      {error && (
        <div className="mt-4 p-4 bg-red-50 border border-red-200 rounded-lg">
          <p className="text-sm text-red-800">{error}</p>
        </div>
      )}
    </div>
  );
};

export default BlotterReportFilters;
